import React from 'react';
import { Anchor } from '@americanexpress/gravity-core';

const GravityFooter = () => (
  <div id="skFooter" className="safekey-footer flex flex-justify-center flex-align-center legal-1 dls-white-bg">
    <footer className="text-align-center">
      <Anchor
        href="https://www.americanexpress.com/us/company/privacy-center/online-privacy-disclosures/"
        target="_blank"
        rel="noreferrer noopener"
        identifier="axp-gravity-footer"
        detail="Online Privacy Statement"
      >
        <span aria-label="Go to American Express privacy center">
          Online Privacy Statement
        </span>
      </Anchor>
    </footer>
  </div>
);

export default GravityFooter;
